import React from 'react'
import ButtonAction, { ButtonActionProps } from 'components/shared/ButtonAction'

const InviteButton: React.FC<Omit<ButtonActionProps, 'text'>> = ({ ...props }) => {
  return <ButtonAction text='Invite' size='large' fullWidth bold {...props} />
}

export default InviteButton
